<template>
  <div class="aliyun-captcha-wrapper">
    <div :id="elementId"></div>
    <button ref="trigger" :id="buttonId" class="aliyun-captcha-trigger" type="button"></button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      elementId: `aliyun-captcha-element-${this._uid}`,
      buttonId: `aliyun-captcha-button-${this._uid}`,
      captcha: null,
      initPromise: null,
      initializedAt: 0,
      triggerTimer: null,
      verifyCallback: null,
      readyResolve: null,
      readyReject: null
    };
  },
  mounted() {
    this.initialize().catch(() => {});
  },
  beforeDestroy() {
    if (this.triggerTimer) clearTimeout(this.triggerTimer);
  },
  methods: {
    initialize() {
      if (this.initPromise) return this.initPromise;

      this.initPromise = new Promise((resolve, reject) => {
        if (typeof window.initAliyunCaptcha !== 'function') {
          reject(new Error('阿里云验证码 SDK 加载失败'));
          return;
        }

        window.initAliyunCaptcha({
          SceneId: 'g0v7c5v0',
          mode: 'popup',
          element: `#${this.elementId}`,
          button: `#${this.buttonId}`,
          captchaVerifyCallback: captchaVerifyParam => this.handleVerify(captchaVerifyParam),
          onBizResultCallback: () => {},
          getInstance: instance => {
            this.captcha = instance;
            this.initializedAt = Date.now();
            resolve(instance);
          },
          onError: error => {
            reject(error);
            this.rejectReady(error);
          }
        });
      });

      return this.initPromise;
    },

    ready(verifyCallback) {
      if (typeof verifyCallback !== 'function') {
        return Promise.reject(new Error('缺少验证码服务端核验回调'));
      }
      if (this.readyReject) {
        return Promise.reject(new Error('验证码正在进行中'));
      }

      return new Promise((resolve, reject) => {
        this.verifyCallback = verifyCallback;
        this.readyResolve = resolve;
        this.readyReject = reject;
        this.initialize().then(() => {
          const waitTime = Math.max(0, 2000 - (Date.now() - this.initializedAt));
          if (waitTime) {
            this.triggerTimer = setTimeout(() => {
              this.triggerTimer = null;
              this.$refs.trigger.click();
            }, waitTime);
          } else {
            this.$refs.trigger.click();
          }
        }).catch(error => {
          this.openMessage(0, '验证服务暂不可用');
          this.rejectReady(error);
        });
      });
    },

    async handleVerify(captchaVerifyParam) {
      try {
        const data = await this.verifyCallback(captchaVerifyParam);
        if (this.readyResolve) this.readyResolve(data);
        this.clearReady();
        return {
          captchaResult: data.captcha_result === true,
          bizResult: true
        };
      } catch (error) {
        const captchaResult = error && error.captcha_result === true;
        if (this.readyReject) this.readyReject(error);
        this.clearReady();
        return {
          captchaResult,
          bizResult: false
        };
      }
    },

    rejectReady(error) {
      if (this.readyReject) {
        this.readyReject(error);
        this.clearReady();
      }
    },

    clearReady() {
      if (this.triggerTimer) {
        clearTimeout(this.triggerTimer);
        this.triggerTimer = null;
      }
      this.verifyCallback = null;
      this.readyResolve = null;
      this.readyReject = null;
    }
  }
};
</script>

<style scoped>
.aliyun-captcha-trigger {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}
</style>
